export default "__VITE_ASSET__1c2fe5a1__"